import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header/Header";
import {
  setCurrentTab,
  setQuickSearch,
} from "../store/reducers/SharedLayoutDataSlice";
import { setClientSalesPerson } from "../store/reducers/clientFilterSlice";
import { checkRouteAccess } from "../utils/route";

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();

  const sharedData = useSelector((state) => state.SharedLayoutData);
  const [Toggle, setToggle] = useState(false);

  const [Tab, setTab] = useState(sharedData.CurrentTab);
  const ChangeTab = (tab) => {
    if (tab === "clients") {
      if (sessionStorage.type === "SP") {
        const name =
          `${sessionStorage.firstName} ${sessionStorage.lastName}`;
        dispatch(setClientSalesPerson(name));
      }
    }

    if (tab === "tickets") {
      dispatch(setQuickSearch(false));
    }

    setTab(tab);
    dispatch(setCurrentTab(tab));
  };

  const ToggleSidebar = () => {
    setToggle(!Toggle);
  };

  useEffect(() => {
    setTab(sharedData.CurrentTab);
  }, [sharedData.CurrentTab]);

  return (
    <>
      <Header />
      <div id="wrapper">
        <div
          id="sidebar-wrapper"
          className={`${Toggle === true ? "sidebar-wrapperToggle" : ""}`}
        >
          <div>
            <ul
              className="sidebar-nav nav-pills nav-stacked"
              role="tablist"
              id="menu"
            >
              {checkRouteAccess("/dashboard", sharedData) && (
                <li role="presentation" className="border p-2 text-capitalize">
                  <Link
                    to="/dashboard"
                    onClick={() => ChangeTab("dashboard")}
                    className={`${Tab === "dashboard" ? "bg-gradient bg-secondary" : ""
                      }`}
                  >
                    <p
                      className={`${Tab === "dashboard" ? "text-white" : "text-black"
                        }`}
                      aria-controls="home"
                      title="Home"
                      role="tab"
                      data-toggle="tab"
                    >
                      <FontAwesomeIcon icon="home" size="lg" />
                      <span className="px-3"> Home </span>
                    </p>
                  </Link>
                </li>
              )}

              {checkRouteAccess("/tickets", sharedData) && (
                <li role="presentation" className="border p-2 text-capitalize">
                  <Link
                    to="/tickets"
                    onClick={() => ChangeTab("tickets")}
                    className={`${Tab === "tickets" ? "bg-gradient bg-secondary" : ""
                      }`}
                  >
                    <p
                      className={`${Tab === "tickets" ? "text-white" : "text-black"
                        }`}
                      aria-controls="tickets"
                      title="Tickets"
                      role="tab"
                      data-toggle="tab"
                    >
                      <FontAwesomeIcon icon="ticket" size="lg" />
                      <span className="px-3"> Tickets </span>
                    </p>
                  </Link>
                </li>
              )}

              {checkRouteAccess("/clients", sharedData) && (
                <li role="presentation" className="border p-1 text-capitalize">
                  <Link
                    to="/clients"
                    onClick={() => ChangeTab("clients")}
                    className={`${Tab === "clients" ? "bg-gradient bg-secondary" : ""
                      }`}
                  >
                    <p
                      className={`${Tab === "clients" ? "text-white" : "text-black"
                        }`}
                      aria-controls="clients"
                      title="Clients"
                      role="tab"
                      data-toggle="tab"
                    >
                      <FontAwesomeIcon icon="user" size="lg" />
                      <span className="px-3"> Clients </span>
                    </p>
                  </Link>
                </li>
              )}

              {checkRouteAccess("/users", sharedData) && (
                <li role="presentation" className="border p-1 text-capitalize">
                  <Link
                    to="/users"
                    onClick={() => ChangeTab("users")}
                    className={`${Tab === "users" ? "bg-gradient bg-secondary" : ""
                      }`}
                  >
                    <p
                      className={`${Tab === "users" ? "text-white" : "text-black"
                        }`}
                      aria-controls="users"
                      title="Users"
                      role="tab"
                      data-toggle="tab"
                    >
                      <FontAwesomeIcon icon="users" size="lg" />
                      <span className="px-3"> Users </span>
                    </p>
                  </Link>
                </li>
              )}

              {checkRouteAccess("/inbox", sharedData) && (
                <li
                  role="presentation"
                  className="border p-1 text-capitalize"
                  onClick={() => ChangeTab("inbox")}
                >
                  <Link
                    to="/inbox"
                    className={`${Tab === "inbox" ? "bg-gradient bg-secondary" : ""
                      }`}
                  >
                    <p
                      className={`${Tab === "inbox" ? "text-white" : "text-black"
                        }`}
                      aria-controls="inbox"
                      title="Inbox"
                      role="tab"
                      data-toggle="tab"
                    >
                      <FontAwesomeIcon icon="inbox" size="lg" />
                      <span className="px-3"> Inbox </span>
                    </p>
                  </Link>
                </li>
              )}
            </ul>
          </div>
          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <label
              className="navbar-icon"
              htmlFor="check"
              onClick={() => ToggleSidebar()}
            >
              <span />
              <span />
              <span />
            </label>
          </div>
        </div>
      </div>
      <main
        className={`${Toggle === true ? "main-dashboardToggle" : ""
          } main-dashboard`}
      >
        {children}
      </main>
    </>
  );
};
export default MainLayout;
